var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39385 9.39385C9.39385 4.20577 5.18808 0 0 0V36.4011C0 38.9952 2.10289 41.098 4.69693 41.098C4.72232 41.098 4.74766 41.0978 4.77296 41.0974C6.00438 41.117 7.24182 40.6639 8.17799 39.7394L19.9022 28.1611V36.813C19.9022 36.8168 19.9022 36.8206 19.9022 36.8244C19.8992 38.0049 20.3618 39.1861 21.2887 40.0834C22.2244 40.9892 23.453 41.4314 24.6747 41.4111C24.7025 41.4115 24.7304 41.4118 24.7584 41.4118C26.6584 41.4118 28.3036 40.3784 29.1014 38.8728L44.4218 23.4266V38.6062C44.4218 43.7942 48.6275 48 53.8156 48V12.2263L53.8155 12.1966L53.8152 12.1648C53.8311 10.9684 53.3687 9.76731 52.4291 8.85776C51.514 7.97184 50.3186 7.52939 49.1236 7.52941L49.1187 7.52941C48.9132 7.52941 48.7107 7.54261 48.5122 7.56821C47.5169 7.69509 46.5555 8.13307 45.7936 8.88157L29.6145 25.1935V16.9909C29.6145 14.4511 27.4403 12.3922 24.7584 12.3922C23.5951 12.3922 22.5273 12.7795 21.691 13.4255C21.4903 13.5687 21.2986 13.7294 21.1181 13.9077L9.39385 25.486V9.39385Z",
    fill: "#FFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1927 37.8039C42.1927 39.7098 40.6245 41.2549 38.6899 41.2549C36.7554 41.2549 35.1871 39.7098 35.1871 37.8039C35.1871 35.898 36.7554 34.3529 38.6899 34.3529C40.6245 34.3529 42.1927 35.898 42.1927 37.8039Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.efb928e39df2086997c70dfe9ee40a67.svg";
export { ForwardRef as ReactComponent };